import { html, TemplateResult } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";

const LawComplianceComponent = (lawComplianceProps: ILawComplianceComponent): TemplateResult => {

  const {
    messages,
    captchaEnabled,
  } = lawComplianceProps

  return html`
      <div class="conditions">
        <div class="links disclaimer">
          <div class="lawcompliance">    
            ${!captchaEnabled ?
        html`<p>${unsafeHTML(messages.PrivacyPolicyDisclaimerTextWithCloseBtn)}</p>` :
        html`<p>${unsafeHTML(messages.PrivacyPolicyDisclaimerTextWhenCaptchaEnabled)}</p>`}
          </div>
      </div>
    </div>
        `
}

export default LawComplianceComponent;